import React from 'react';
import css from './PackagesBenefitsModal.css';
import { IconCheckCircleL } from '../../icons';

export default ({ isProfilePackageType }) => (
    <>
        <h3 className={css.title}>
            {isProfilePackageType
                ? 'Mach dein Profil unsichtbar bis zum Match'
                : 'Mach das Profil unsichtbar bis zum Match'}
        </h3>
        <p className={css.description}>Das Zusatzpaket beinhaltet folgende Leistungen:</p>
        <div className={css.benefitsHolder}>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Trotz Verfügbarkeit erscheint dein Reiter-Profil nicht in unseren Suchergebnissen oder der Karte.'
                        : 'Trotz Veröffentlichung erscheint das Pferde-Profil nicht in unseren Suchergebnissen oder der Karte.'}
                </p>
            </div>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Pferdebesitzer:innen können nicht sehen, ob Du ihr Pferde-Profil angesehen hast.'
                        : 'Pferdemenschen können nicht sehen, ob Du ihr Reiter-Profil angesehen hast.'}
                </p>
            </div>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Pferdebesitzer:innen können nicht sehen, ob Du ihr Pferde-Profil favorisiert hast.'
                        : 'Pferdemenschen können nicht sehen, ob Du ihr Reiter-Profil favorisiert hast.'}
                </p>
            </div>
        </div>
    </>
);
